import './styles/action-button.scss'

import React       from 'react'
import PropTypes   from 'prop-types'
import { connect } from 'react-redux'
import classnames  from 'classnames'

import { Modal, Button, Header, Icon } from 'semantic-ui-react'

import { getFormattedError } from '../graphql/utils'

const ALLOWD_IN_ROLES = [
  'admin',
  'power_user',
]

class ActionButton extends React.Component {
  static propTypes = {
    user:         PropTypes.object,
    featureFlags: PropTypes.array.isRequired,

    buttonIconName:          PropTypes.string.isRequired,
    buttonText:              PropTypes.string.isRequired,
    buttonColor:             PropTypes.string,
    onPerformAction:         PropTypes.func.isRequired,
    onPerformActionComplete: PropTypes.func.isRequired,
    confirmationHeader:      PropTypes.string,
    confirmationTitle:       PropTypes.string,
  }

  state = {
    confirm:  false,
    starting: false,
    error:    null,
  }

  handleClick = (event) => {
    event.preventDefault()
    event.stopPropagation()

    const { confirmationHeader, confirmationTitle } = this.props
    const { starting, error } = this.state

    if (!starting && !error) {
      if (confirmationHeader && confirmationTitle) {
        this.setState({ confirm: true })
      } else {
        this.handleConfirm()
      }
    }
  }

  handleClose = (event) => {
    event.stopPropagation()    
    this.setState({ confirm: false })
  }

  handleConfirm = (event) => {
    event && this.handleClose(event)

    this.setState({ starting: true }, () => {
      this.props.onPerformAction(this.props).then((result) => {
        this.setState({ error: result.errorMessage, starting: false }, () => {
          this.props.onPerformActionComplete(result)
        })
      }).catch((error) => {
        this.setState({ error: getFormattedError(error), starting: false })
      })
    })
  }

  render() {
    const { featureFlags, user, buttonText, confirmationTitle, confirmationHeader, buttonIconName } = this.props
    const { starting, error } = this.state

    const allowedByRole = !featureFlags.includes('roles') || (user && ALLOWD_IN_ROLES.includes(user.role))
    if (!allowedByRole) {
      return null
    }
    
    const className = classnames('action-button', { starting, error })

    const icon = starting
      ? 'spinner'
      : buttonIconName

    const loading = starting

    const style = this.props.buttonColor && {
      backgroundColor: this.props.buttonColor,
    }
    
    return (
      <div className={className} style={style} onClick={this.handleClick}>

        { !error && <Icon name={icon} loading={loading} /> }
        { !error && <div>{ buttonText }</div> }

        {  error && error }

        <div className="modal-div">
          <Modal centered={false} open={this.state.confirm}>
            <Header icon='shipping fast' content={confirmationHeader} />
            <Modal.Content>
              <h5>{confirmationTitle}</h5>
            </Modal.Content>
             <Modal.Actions>
              <Button onClick={this.handleClose}>Cancel</Button>
              <Button onClick={this.handleConfirm} primary>OK</Button>
            </Modal.Actions>
          </Modal>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = {}
const mapStateToProps = (state) => ({
  user:         state.auth.user,
  featureFlags: state.features.featureFlags,
})

export default connect(mapStateToProps, mapDispatchToProps)(ActionButton)
